import React, { useEffect, useReducer, useState } from 'react';
import { Button, Tab, Tabs } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import IntegrationSource from '../../../../../../shared/integration-source/IntegrationSource';
import { formDataValidate } from '../../../../../../utils/formUtils';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../env/Configurations';
import { fetchIntegrationStatus, fetchIntegrationConfigs } from '../../../../configurationSlice';

const TravelService = ({ selectedHotel, showLoader = () => {} }) => {
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    if (selectedHotel) {
      dispatch(fetchIntegrationStatus(selectedHotel));
      dispatch(fetchIntegrationConfigs('config'));
      dispatch(fetchIntegrationConfigs('map'));
    }
  }, [selectedHotel]);

  const [formData, setFormData] = useReducer((s, n) => ({ ...s, ...n }), {
    integrationSource: { value: '', fieldName: 'Integration Source', errors: {}, validations: [] },
    integrationSourceSelected: { value: '', fieldName: 'Vendor', errors: {}, validations: [] },
  });

  const validate = () => {
    const updated = {};
    const ok = formDataValidate(formData, updated);
    setFormData(updated);
    return ok;
  };

  const handleTabChange = (e, v) => setTabValue(v);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(stepUpLoaderCount());
      if (!validate()) return;
      notificationManager('success', 'Travel Service settings saved');
    } catch (err) {
      if (ENVIRONMENT === 'dev') console.log(err?.message);
      notificationManager('danger', 'Unable to save Travel Service settings');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  return (
    <form onSubmit={handleSubmit} className='ts' noValidate>
      <div className='col-12 hotel-service-tab-section'>
        <div className='col col-xl-6'>
          <Tabs
            value={tabValue}
            variant='fullWidth'
            indicatorColor='primary'
            onChange={handleTabChange}
            textColor='primary'
            className='property-tabs'
          >
            <Tab label='Integration Settings' />
          </Tabs>
        </div>
      </div>

      {tabValue === 0 && (
        <div className='mx-4'>
          <IntegrationSource
            formData={formData}
            setFormData={setFormData}
            section='Travel Service'
            headTitle='Integration Source'
            showLoader={showLoader}
          />
        </div>
      )}
    </form>
  );
};

export default TravelService;
